export default __webpack_public_path__ + "static/5_Screenshot-c152820c1aefef72a039c19a8d3d006c.png";